import { render } from "./SelectAnswer.vue?vue&type=template&id=3f07d75c"
import script from "./SelectAnswer.vue?vue&type=script&lang=js"
export * from "./SelectAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__